import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect, useState } from 'react';

import { Button, Col, Form, Input, Modal, Row, Spin, Table, TableColumnsType } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getKrConfirmCompleteQuarter, reset, saveCompleteQuarter } from 'app/entities/activities/activities.reducer';
import { displayPercent } from 'app/shared/util/percent';
import { Container } from 'reactstrap';
import * as _ from 'lodash';
import '../style.scss';

type IConfirmCompleteProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  isShow?: boolean;
};

export const ConfirmCompleteQuarter = ({ isOpen, isShow = true, onClose }: IConfirmCompleteProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.activities);
  const updating = useAppSelector(state => state.activities.updating);
  const loading = useAppSelector(state => state.activities.loading);
  const updateSuccess = useAppSelector(state => state.activities.updateSuccess);

  const [data, setData] = useState(null);

  const columnsResult: TableColumnsType<any> = [
    {
      key: 'workStatusName',
      dataIndex: 'workStatusName',
      width: 200,
    },
    {
      title: 'Số công việc (T)',
      key: 'quarterCount',
      align: 'center',
      dataIndex: 'quarterCount',
    },
    {
      title: 'Tỷ lệ',
      key: 'quarterProportion',
      align: 'center',
      dataIndex: 'quarterProportion',
      render: item => `${displayPercent(item).toFixed(2)}%`,
    },
  ];

  useEffect(() => {
    if (filters?.accountableId) innitData();
  }, [filters]);

  const innitData = async () => {
    const response = await dispatch(
      getKrConfirmCompleteQuarter({ partyId: filters?.accountableId }),
    );

    if (response && response.payload) {
      const result = response.payload as any;
      if (result.data) {
        setData(result.data);
        form.setFieldsValue({
          ...result.data,
          outstandingResults: result.data?.outstandingResults?.map(item => ({ outstandingResult: item })),
          adjustmentNotes: result.data?.adjustmentNotes?.map(item => ({ adjustmentNote: item })),
          issues: result.data?.issues?.map(item => ({ issues: item })),
          proposals: result.data?.proposals?.map(item => ({ proposal: item })),
        });
      }
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose(updateSuccess);
    }
  }, [updateSuccess]);

  const mapperDataPayload = (values, isDraft = false) => {
    const payload = {
      ...values,
      partyId: filters?.accountableId,
      outstandingResults: values.outstandingResults?.map(item => item.outstandingResult),
      adjustmentNotes: values.adjustmentNotes?.map(item => item.adjustmentNote),
      issues: values.issues?.map(item => item.issues),
      proposals: values.proposals?.map(item => item.proposal),
      isDraft,
    };
    return payload;
  }

  const handleSubmit = values => {
    const payload = mapperDataPayload(values);
    dispatch(saveCompleteQuarter(payload));
  };

  const handleSaveDraft = () => {
    form.validateFields().then(values => {
      const payload = mapperDataPayload(values, true);
      dispatch(saveCompleteQuarter(payload));
    }).catch(() => { return; });
  };

  const handleClose = (reload = false) => {
    onClose(reload);
    dispatch(reset())
  };

  return (
    <Modal
      width={1150}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Spin spinning={loading || updating} delay={300}>
          <Form initialValues={{
            outstandingResults: [{}],
            proposals: [{}],
            issues: [{}],
            adjustmentNotes: [{}],
            essentials: [{}]
          }} size="large" form={form} onFinish={handleSubmit} layout="vertical">
            <Title level={3}>{`Xác nhận hoàn thành check in ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
            <Row>
              <Col>
                <Form.Item label="Kỳ báo cáo">
                  <Input disabled value={data?.reportScheduleName} />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h5">I. KẾT QUẢ THỰC HIỆN CÔNG VIỆC {data?.reportScheduleName}</span>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h6">1. Tổng hợp kết quả thực hiện</span>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <Table
                  pagination={false}
                  bordered
                  dataSource={data?.workLoads}
                  columns={columnsResult}
                  className="w-100"
                  rowClassName={(record, index) => {
                    return index === data?.workLoads.length - 1 ? 'fw-bold' : '';
                  }}
                />
              </Col>
            </Row>
            <Form.Item>
              <Row className="action" justify="end">
                <Col>
                  <Button
                    className="green"
                    onClick={() => {
                      handleSaveDraft();
                    }}
                    disabled={updating}
                  >
                    Lưu nháp
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit" disabled={updating}>
                    Xác nhận hoàn thành
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Container>
    </Modal>
  );
};

export default ConfirmCompleteQuarter;
